import Styles from './CollapseButton.module.scss'
import cx from 'classnames'
import { ReactComponent as ChevronRightIcon } from 'assets/icons/doubleChevronRight16.svg'
import { ReactComponent as ChevronLeftIcon } from 'assets/icons/doubleChevronLeft16.svg'
import { IconButton } from 'components/IconButton/IconButton'
import { observer } from 'mobx-react-lite'
import { computed } from 'mobx'
import { useLayout } from 'stores/LayoutStore'

interface Props {
  positionNotFixed?: boolean
}

export const CollapseButton = observer(({ positionNotFixed = false }: Props) => {
  const layout = useLayout()
  const isLocked = computed(() => layout.rightColumnLocked).get()
  const Icon = isLocked ? ChevronRightIcon : ChevronLeftIcon

  return (
    <IconButton
      icon={Icon}
      className={cx(Styles.collapseButton, {
        [Styles.collapsed]: !isLocked,
        [Styles.positionNotFixed]: positionNotFixed,
      })}
      onPress={() => layout.setRightColumnLocked(!isLocked)}
    />
  )
})
